import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-customer-plans-system-modules',
  templateUrl: './customer-plans-system-modules.component.html',
  styleUrls: ['./customer-plans-system-modules.component.sass']
})
export class CustomerPlansSystemModulesComponent implements OnInit {
  systemModules: any[] = [];
  customerPlanAudits: any[] = [];
  customerPlans: any[] = [];
  canceledAt = '';
  cancellationReason = '';
  showPlans: boolean = false;
  title: string = '';

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CustomerPlansSystemModulesComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dataDialog: any
  ) {
    console.log('Dados recebidos no diálogo:', this.dataDialog);

    // Garantir que dataDialog e element existam
    if (!this.dataDialog) {
      this.dataDialog = {};
    }

    if (!this.dataDialog.element) {
      this.dataDialog.element = {};
    }

    this.systemModules = this.dataDialog?.element?.systemModules || [];
    this.canceledAt = this.dataDialog?.element?.canceledAt || '';
    this.cancellationReason = this.dataDialog?.element?.cancellationReason || '';
    this.customerPlanAudits = this.dataDialog?.element?.customerPlanAudits || [];
    this.customerPlans = this.dataDialog?.element?.customerPlans || [];
    this.title = this.dataDialog?.title || 'MÓDULOS DO SISTEMA';
    this.showPlans = this.customerPlans && this.customerPlans.length > 0;


  }

  ngOnInit(): void {
    if (this.showPlans) {
      console.log('Exibindo lista de planos do cliente');
    } else if (!this.systemModules || this.systemModules.length === 0) {
      console.warn('Nenhum módulo carregado para exibição');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  getTotalMonthlyValue(): number {
    return this.customerPlans
      .filter((plan) => plan.active)
      .reduce((acc, plan) => acc + (+plan.monthlyValue || 0), 0);
  }

  getTotalAdhesionFee(): number {
    return this.customerPlans
      .filter((plan) => plan.active)
      .reduce((acc, plan) => acc + (+plan.adhesionFee || 0), 0);
  }

  getTotalDeploymentValue(): number {
    return this.customerPlans
      .filter((plan) => plan.active)
      .reduce((acc, plan) => acc + (+plan.deploymentValue || 0), 0);
  }

  getTotalDaysCountValue(): number {
    return this.customerPlans
      .filter((plan) => plan.active)
      .reduce((acc, plan) => acc + (+plan.daysCountValue || 0), 0);
  }

  viewPlanModules(plan: any): void {
    if (!plan.systemModules || plan.systemModules.length === 0) {
      return;
    }

    // Abrir um diálogo para exibir os módulos deste plano
    const dialogRef = this.dialog.open(CustomerPlansSystemModulesComponent, {
      width: '650px',
      data: {
        element: {
          systemModules: plan.systemModules
        },
        title: `MÓDULOS DO PLANO: ${plan.code} - ${plan.system}`,
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Diálogo de módulos fechado');
    });
  }

  showPlanInfo(plan: any): void {
    const dialogRef = this.dialog.open(CustomerPlansSystemModulesComponent, {
      width: '650px',
      data: {
        element: {
          customerPlanAudits: plan.customerPlanAudits || [],
          canceledAt: plan.canceledAt || '',
          cancellationReason: plan.cancellationReason || '',
          observation: plan.observation || '',
          isInfoOnly: true
        },
        title: `INFORMAÇÕES DO PLANO: ${plan.code} - ${plan.system}`,
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Diálogo de informações fechado');
    });
  }
}
